import { scope, scopeNode } from '#components/generics/js/selectors/scope.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import report from '#utilities/js/ea/report.js'
import local from '../../common/storage/local.js'
import list from '../../common/fs/list.js'
import { create, remove } from '../../common/fs/dir.js'
import app, { update } from '../../common/app/app.js'
import { authUser, startTime } from '../../common/app/vars.js'
import { user, updateTime, updateStyle, dontReload } from '../../common/storage/vars.js'
/* on importe le dispatcher pour lancer la boucle asynchrone */
/* on ne doit pas supprimer cet import, même s'il n'y a pas */
/* d'utilisation directe dans ce module */
import appDispatcher from './dispatcher.js'

export default async (elem) => {
  const scopeNode = one('span[data-scope-json]', elem)
  const scopeProps = scope(scopeNode)
  const {
    host,
    serverVersion,
    imgJsUrl = [],
    imgUrl = [],
    imgCssUrl = []
  } = scopeProps
  const clientVersion = local.get(updateTime)
  const { authUser, isOnline, startTime, readPath } = app()


  if (isOnline && readPath) {
    try {
      const files = await list(readPath)
      console.log(files)
      if (files.length < 20 || !clientVersion
        || clientVersion !== serverVersion) {
        const allUrls = [ ...imgJsUrl, ...imgUrl, ...imgCssUrl]
        for (const url of allUrls) {
          /* TODO: ea_local_download.... */
        }
        /* local.set(updateStyle, 1) */
      }
    } catch (e) {
      report(new Error('app init: ' + JSON.stringify(e)))
    }
  }
  local.set(updateTime, serverVersion)
  local.remove(dontReload)
  update(authUser, local.get(user))
  update(startTime, Math.floor(Date.now() / 1000))
  updateBaseHref(host)
}

const updateBaseHref = (host) => {
  const { document } = defaults
  const bases = document.getElementsByTagName('base')
  const { base_href } = app()
  const scheme = base_href.startsWith('https://') ? 'https://' : 'http://'
  if (bases && bases.length > 0) {
    bases[0].href = scheme + host
  }
}
